module.exports = __webpack_public_path__ + "img/4.74d837c3.png";